import React from 'react';
import {
  Heading1, Heading2, List, Paragraph, Span,
} from '../../components/typography';
import { Row, Col, Container } from '../../components/grid';
import { ItemTraverser } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';
import RowProductView from '../../components/grid/RowProductView';

export default () => (
  <SidemenuLayout menuPicker="Alkohol" activeSidemenu="Alkoholfri">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>Alkoholfri øl</Heading1>
          <Paragraph>
            Her på siden finder du et bredt udvalg af letøl og alkoholfri øl på flaske. Der er tale om øl, der kun har en alkoholprocent på mellem 0,0% og 2,7%. Grundet de lave procenter, indeholder alkoholfri øl mange færre kalorier, men du får stadig den autentiske smag af øl, som du kender det - bare uden alkoholen. Vælg mellem mange varianter fra bl.a. Carlsberg, Tuborg, Skovlyst, Heineken m.fl.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="alkoholfrioel" display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Alkoholfri øl - ingen procenter, men masser af smag</Heading2>
          <Paragraph>
            Øl uden alkohol er på vej frem og bliver mere og mere populært, for hvert år der går. Og det giver rigtig god mening. Når du vælger alkoholfri øl, får du nemlig ingen eller et minimalt indhold af alkohol, færre kalorier og samme gode smag, som du allerede kender fra den skønne, gyldne drik.
          </Paragraph>
          <Paragraph>
            Når du drikker en øl uden alkohol, vil du få samme forfriskende følelse som ved en almindelig øl. Du vil opleve den samme perlende fornemmelse, sødmen og bitterheden, da det ikke er alkoholen der påvirker smagen.
          </Paragraph>
          <Paragraph>
            Der kan være mange årsager til at nyde en øl uden alkoholprocenter, eksempelvis graviditet, sygdom, et aktivt valg, et sundsmæssigt valg eller hvis du skal køre hjem - dette behøver dog ikke holde dig tilbage for stadig at nyde den læskende og iskolde øl.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Smag dig gennem vores udvalg af alkoholfri øl på flaske</Heading2>
          <Paragraph>
            Der er masser at vælge mellem, når du vil nyde en forfriskende alkoholfri øl på flaske.
          </Paragraph>
          <Paragraph>
            Blandt vores udvalg finder du eksempelvis:
          </Paragraph>
          <List>
            <li>Tuborg uden alkohol - også kendt som Tuborg Nul</li>
            <li>Carlsberg alkoholfri øl</li>
            <li>Heineken alkoholfri øl</li>
            <li>Skovlyst alkoholfri øl</li>
            <li>KB hvidtøl</li>
            <li>Vestfyen light øl</li>
          </List>
          <Paragraph>
            <Span underline>Alkoholfri Tuborg</Span><br />
            Hvis du ønsker en Tuborg alkoholfri øl har du flere varianter at vælge iblandt. Du kan vælge den helt klassiske version af en alkoholfri Tuborg på glasflaske eller på dåse. De sælges som hele kasser eller rammer. Der er hhv. 30 x 33 cl glasflasker i en kasse og 24 x 33 cl dåser i en ramme.<br />
            Alkoholprocent: 0,0%
          </Paragraph>
          <Paragraph>
            Ønsker du en mere frisk og sommerlig variant, bør du prøve Tuborg Nul Citrus, hvor den tilsatte smag af citrus gør den alkoholfri øl letdrikkelig og ultra frisk. Dette er en øl for alle - også dem, der normalt ikke drikker øl.<br />
            Alkoholprocent: 0,0%
          </Paragraph>
          <Paragraph>
            <Span underline>Carlsberg alkoholfri øl</Span><br />
            Vælg mellem Nordic eller Nordic Ale. Den klassiske Nordic er en frisk og læskende pilsner, mens Nordic Ale byder på en flot mørk farve fra karamelmalten og en skøn sødme.
            Vælg mellem en kasse eller ramme med 24 stk. á 33 cl.<br />
            Alkoholprocent: 0,5%
          </Paragraph>
          <Paragraph>
            <Span underline>Heineken alkoholfri øl</Span><br />
            En alkoholfri Heineken smager nøjagtigt som du kender og kan lide den. Frisk aroma og en let, sød smag.
            Vælg mellem en kasse eller ramme med 24 stk. á 33 cl.<br />
            Alkoholprocent: 0,0%
          </Paragraph>
          <Paragraph>
            <Span underline>Skovlyst alkoholfri øl</Span><br />
            En skøn IPA, der er kraftig og fyldig i smagen samt har en forfriskende bitterhed.
            Sælges på glasflaske på 50 cl. med 15 stk. i en kasse.<br />
            Alkoholprocent: 0,5%
          </Paragraph>
          <Paragraph>
            <Span underline>KB hvidtøl</Span><br />
            Sødlig øl fra Kongens Bryghus med lavt indhold af alkohol.
            Hvidtøl er den oprindelige øltype i Danmark, som blev brygget på bøndergårdene. Øllen egner sig godt til eksempelvis risengrød og smørrebrød.
            Sælges på glasflaske på 33 cl. med 30 stk. i en kasse.<br />
            Alkoholprocent: 1,7%
          </Paragraph>
          <Paragraph>
            <Span underline>Vestfyen Light</Span><br />
            Vestfyen light øl indeholder lidt alkohol, men procenten er i den lave ende. Perfekt til dig, der godt vil spare en smule på promillen eller kalorierne, men ikke ønsker en øl uden alkohol. Den gode pilsnersmag er bevaret.
            Sælges på glasflaske på 33 cl. med 30 stk. i en kasse.<br />
            Alkoholprocent: 2,7%
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading2>Skafte leverer alkoholfri øl til både privat og erhverv</Heading2>
          <Paragraph>
            Hos Skafte leverer vi alkoholfri øl til både privat forbrug og til erhverv.
          </Paragraph>
          <Paragraph>
            <Span underline>Privat:</Span><br />
            Ønsker du at nyde en øl, men samtidig spare på promillerne eller kalorierne? Når du vælger en alkoholfri øl på flaske, kan du nyde den samme gode smag som du kender den fra klassisk øl, bare lettere.
            Der kan være mange årsager til at drikke øl uden alkohol, eksempelvis ved sygdom, af sundhedsmæssige årsager og graviditet.
            Vi leverer øllen, uanset om det er til din næste fest eller arrangement, men også hvis du blot ønsker at have en eller flere kasser/rammer på lager til dit eget forbrug.
            Det kan også være en fordel at have lidt på lager, når du får gæster, der skal køre hjem.
          </Paragraph>
          <Paragraph>
            <Span underline>Erhverv:</Span><br />
            Imødekom alle på arbejdspladsen til næste firmaarrangement eller -fest, ved at kunne tilbyde en læskende alkoholfri øl som alternativ til de andre drikkevarer. Det er langt fra alle der ønsker at indtage alkohol, men som stadig ønsker at deltage på lige fod med de andre, uden at skulle drikke vand eller sodavand.
            Øl uden alkohol er også en fordel, hvis der er kollegaer, der skal køre hjem fra arrangementet.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
